import { useLayoutEffect } from "react";
import { useOutletContext } from "react-router-dom";

type OutletContextType = {
  setPageTitle?: (t: string) => void;
};

export const PageTitle = ({ title }: { title: string }) => {
  const context = useOutletContext<OutletContextType>();

  useLayoutEffect(() => {
    // ✅ SAFE CALL (prevents crash)
    context?.setPageTitle?.(title);
  }, [title, context]);

  return null;
};